import React, { useState } from "react";
import { Send, Sparkles } from "lucide-react";

export default function MessageInput({ onSend, disabled }) {
  const [value, setValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!value.trim() || disabled) return;
    onSend(value);
    setValue("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="border-t border-white/10 bg-[#0A0A0C] p-3 flex items-center gap-2"
    >
      <Sparkles size={14} className="text-[#FF5722] ml-2 shrink-0" />
      <input
        data-testid="ai-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
        placeholder="Ask about materials, tolerances, overhangs…"
        className="flex-1 bg-transparent border-none outline-none font-mono text-sm text-white placeholder:text-zinc-600 disabled:opacity-50"
      />
      <button
        type="submit"
        data-testid="ai-send-button"
        disabled={disabled || !value.trim()}
        className="px-4 h-10 bg-[#FF5722] hover:bg-[#F4511E] disabled:opacity-30 disabled:cursor-not-allowed text-white text-xs font-mono uppercase tracking-[0.2em] flex items-center gap-2 transition-colors"
      >
        <Send size={12} />
        Send
      </button>
    </form>
  );
}
